import { useTranslation } from 'react-i18next';
import type { PageSuggestion } from '../utils/page-suggestions';
import { BotAvatar } from './BotAvatar';
import { OptiBotSuggestions } from './OptiBotSuggestions';

interface WelcomeHeroProps {
  suggestions: PageSuggestion[];
  onSuggestionClick: (question: string) => void;
  /** Show the contextual suggestion pills (empty chat only). The greeting itself
   *  always renders so it stays pinned at the top once the conversation starts. */
  showSuggestions: boolean;
}

/**
 * Opening OptiBot greeting. Rendered to match a normal assistant message — a
 * small bot avatar with the greeting text beside it — and kept as the first item
 * in the message list so it persists after the conversation starts. The
 * suggestion pills only appear on the empty chat.
 */
export function WelcomeHero({ suggestions, onSuggestionClick, showSuggestions }: WelcomeHeroProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-start gap-2">
        <BotAvatar />
        <p className="pt-1 text-sm text-foreground">
          <span className="font-semibold">{t('optibot.welcomeLead')}</span>{' '}
          {t('optibot.welcomeBody')}
        </p>
      </div>
      {/* Suggestions indented to align with the message text (avatar + gap = 36px). */}
      {showSuggestions && (
        <OptiBotSuggestions
          suggestions={suggestions}
          onSuggestionClick={onSuggestionClick}
          stacked
          className="ml-9"
        />
      )}
    </div>
  );
}
